import { DecodedToken } from "src/redux/types/auth";


export const hasRole = (
  decoded: DecodedToken | null,
  role: string
): boolean => {
  return decoded?.["cognito:groups"]?.includes(role) ?? false;
};

export const hasAnyRole = (
  decoded: DecodedToken | null,
  roles: string[]
): boolean => {
  const groups = decoded?.["cognito:groups"] ?? [];

  return roles.some((role) => groups.includes(role));
};
